if (theme_object.animations_enabled == 1) {
    function isScrolledIntoView(elem) {
        var docViewTop = window.scrollY + (window.innerHeight / 4);
        var docViewBottom = docViewTop + window.innerHeight - (window.innerHeight / 3);

        var elemTop = elem.getBoundingClientRect().top + window.scrollY;
        var elemBottom = elemTop + elem.offsetHeight;

        return elemTop <= docViewBottom; //) && (elemTop >= docViewTop)
    }

    var count = 0;
    function animateAll(allowDelay = false) {
        document.querySelectorAll('[data-animation]').forEach(function (elem) {
            if (isScrolledIntoView(elem) && !elem.classList.contains('animate__animated')) {
                count++;
                var animation = elem.getAttribute('data-animation');

                if (allowDelay === true) {
                    elem.style.animationDelay = (count * 0.1) + 's';
                }
                elem.classList.add('animate__animated');
                elem.classList.add('animate__' + animation);

                // reset subtle fade in
                setTimeout(function () {
                    count = 0;
                }, 50);
            }
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        animateAll(true);

        setTimeout(function() { // extra to make sure everything is loaded
            animateAll(true);
        }, 300);

        window.addEventListener('scroll', function () {
            animateAll(true);
        });
    });
}
